export default __webpack_public_path__ + "static/media/Greeting-Mani.ca43d7d9.png";